export default {
    getByProjects: (state) => {
        if (state.report && state.report.byProject) {
            return state.report.byProject
        }
        return []
    },
    getSelectedArchiveProject: (state) => {
        return state.selectedArchiveProject
    },
    getQueryData: (state) => {
        return state.searchQueryData
    },
    getStatusDataBySite: (state) => {
        return state.statusDataBySite
    },
    getFilteredArchiveProjects: (state, getters, _, rootGetters) => {
        let allProjects = rootGetters['projectsModule/getAllProjects']
        if (allProjects.length > 0) {
            let filteredProjects = allProjects
            if (state.searchQueryData.query.length > 0) {
                filteredProjects = allProjects.filter(project => project.name && project.name.toLowerCase().includes(state.searchQueryData.query.toLowerCase()))
            }
            if (state.searchQueryData.active.value !== 'ALL') {
                filteredProjects = filteredProjects.filter(project => project.status === state.searchQueryData.active.value)
            }
            if (state.searchQueryData.projectType.value !== 'ALL') {
                filteredProjects = filteredProjects.filter(project => project.types.includes(state.searchQueryData.projectType.value))
            }

            if (state.searchQueryData.sort) {
                if (state.searchQueryData.sort.value === 'ASCENDING') {
                    filteredProjects = filteredProjects.sort((a, b) => (a.name > b.name) ? 1 : -1);
                } else {
                    filteredProjects = filteredProjects.sort((a, b) => (a.name > b.name) ? -1 : 1);
                }
            }
            return filteredProjects
        } else {
            return allProjects
        }
    },
    getAllRules(state){
        return state.allRules
    },
    getAppliedProjectRule: (state) => (projectId) => {
        if (!state.appliedProjectRule || !projectId) return null
        const rule = state.appliedProjectRule[projectId]
        return rule && Object.keys(rule).length > 0 ? rule : null
    },
    getAppliedSiteRule: (state) => (siteId) => {
        if (!state.appliedSiteRules || !siteId) return null
        const rule = state.appliedSiteRules[siteId]
        return rule && Object.keys(rule).length > 0 ? rule : null
    },
    getAppliedDeviceRule: (state) => (deviceId) => {
        if (!state.appliedDeviceRules || !deviceId) return null
        const rule = state.appliedDeviceRules[deviceId]
        return rule && Object.keys(rule).length > 0 ? rule : null
    },
}
